(function () {
  'use strict';

  const mobile = window.matchMedia('(max-width: 767px)');
  function sync(root) {
    root.querySelectorAll('[data-footer-accordion]').forEach((details) => {
      if (details.dataset.footerAccordionMode === String(mobile.matches)) return;
      details.dataset.footerAccordionMode = String(mobile.matches);
      details.open = !mobile.matches;
      details.querySelector('summary').tabIndex = mobile.matches ? 0 : -1;
    });
  }
  if (!window.__radianFooterAccordionReady) {
    window.__radianFooterAccordionReady = true;
    mobile.addEventListener('change', () => sync(document));
    document.addEventListener('shopify:section:load', (event) => sync(event.target));
  }
  sync(document);
})();
